import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

// 导入 Tailwind CSS
import './assets/tailwind.css'

// 导入 Font Awesome
import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')